import type { ComponentProps, PropsWithChildren, ReactElement } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';

import { useOnObserved } from '../../hooks/use-on-observed';
import { Flex } from '../Flex';
import GradientBlock from '../GradientBlock';

export interface BlockProps extends PropsWithChildren {
  startColor: Nullable<string>;
  endColor: Nullable<string>;
  onView?: () => void;
  disclaimer?: Nullable<ReactElement<any>>;
  displayFlexRow?: boolean;
  isVertical?: boolean;
  isContentCenterAligned?: Nullable<boolean>;
  withBorderRadius?: boolean;
}

const UnstyledVoucherContent = styled(GradientBlock)``;

const VoucherContent = (props: ComponentProps<typeof UnstyledVoucherContent>) => (
  <UnstyledVoucherContent
    color="sys.neutral.border.strong"
    alignItems="center"
    flexWrap="wrap"
    px="sp_16"
    py="sp_8"
    mb={['sp_16', 'sp_20', null, 'sp_24']}
    {...props}
  />
);

const Block = ({
  onView,
  startColor,
  endColor,
  children,
  disclaimer,
  displayFlexRow,
  isVertical,
  isContentCenterAligned,
  withBorderRadius,
  ...props
}: BlockProps) => {
  const ref = useOnObserved(onView);

  return (
    <Flex flexDirection={displayFlexRow ? 'row' : 'column'} data-testid="voucher" ref={ref}>
      <VoucherContent
        {...props}
        startColor={startColor}
        endColor={endColor}
        {...(isVertical
          ? {
              flexDirection: 'column',
              alignItems: isContentCenterAligned ? 'center' : 'flex-start',
            }
          : {})}
        {...(displayFlexRow
          ? {
              bg: 'transparent',
              px: 'sp_0',
              py: 'sp_0',
            }
          : {})}
        {...(withBorderRadius
          ? {
              borderRadius: 'medium',
            }
          : {})}
      >
        {children}
      </VoucherContent>
      {disclaimer}
    </Flex>
  );
};

export default Block;
